/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BrandsActionStatusData,
  BrandsActionTransitionData,
  BrandsActionTransitionTypeEnum,
  CreateBrandsMinimumOrderValueSettingsData,
  CreateBrandsMinimumOrderValueSettingsTypeEnum,
  CreateBrandsMinimumOrderValueSettingsTypeEnum1,
  GetApiInternalV1BrandsBrandIdData,
  GetApiInternalV1BrandsBrandIdParams,
  GetApiInternalV1BrandsProductScoresAggregateData,
  GetApiInternalV1BrandsProductScoresData,
  GetApiInternalV1BrandsProductScoresParams,
  GetBrandMarketingCardsData,
  GetBrandRetailerData,
  GetBrandsCompanyData,
  ListBrandsMinimumOrderValueSettingsData,
  PatchApiInternalV1BrandsBrandIdData,
  PatchApiInternalV1BrandsBrandIdStatusEnum1,
  UpdateBrandRetailerData,
  UpdateBrandsCompanyData,
  UpdateBrandsCompanyTypeEnum,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Brands<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
 * @description Get Brand details
 *
 * @tags AnkorstoreInternal_Brands
 * @name GetApiInternalV1BrandsBrandId
 * @summary Get Brand details
 * @request GET:/api/internal/v1/brands/{brandId}
 * @response `200` `GetApiInternalV1BrandsBrandIdData` Single Brand resource response
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getApiInternalV1BrandsBrandId = ({ brandId, ...query }: GetApiInternalV1BrandsBrandIdParams, params: RequestParams = {}) =>
    this.request<
      GetApiInternalV1BrandsBrandIdData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/${brandId}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
 * @description Updates Brand details
 *
 * @tags AnkorstoreInternal_Brands
 * @name PatchApiInternalV1BrandsBrandId
 * @summary Update Brand details
 * @request PATCH:/api/internal/v1/brands/{brandId}
 * @response `200` `PatchApiInternalV1BrandsBrandIdData` Single Brand resource response
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `422` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unprocessable Entity : Data provided is invalid
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  patchApiInternalV1BrandsBrandId = (
    brandId: string,
    data: {
      status?: PatchApiInternalV1BrandsBrandIdStatusEnum1;
      /** @format date */
      holidayStartDate?: string;
      /** @format date */
      holidayEndDate?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<
      PatchApiInternalV1BrandsBrandIdData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/${brandId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
 * @description Gets Brand's company details
 *
 * @tags AnkorstoreInternal_Brands
 * @name GetBrandsCompany
 * @summary Get Brand's company
 * @request GET:/api/internal/v1/brands/company/{companyId}
 * @response `200` `GetBrandsCompanyData` Single company resource response
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getBrandsCompany = (companyId: string, params: RequestParams = {}) =>
    this.request<
      GetBrandsCompanyData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/company/${companyId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Updates Brand's company details
 *
 * @tags AnkorstoreInternal_Brands
 * @name UpdateBrandsCompany
 * @summary Update Brand's company
 * @request PATCH:/api/internal/v1/brands/company/{companyId}
 * @response `200` `UpdateBrandsCompanyData` Single company resource response
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `422` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unprocessable Entity : Data provided is invalid
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  updateBrandsCompany = (
    companyId: string,
    data: {
      data: {
        type: UpdateBrandsCompanyTypeEnum;
        attributes: {
          founded_in_year?: number | null;
          company_name?: string | null;
          company_invoice_description?: string | null;
          legal_form?: string | null;
          city_of_registration?: string | null;
          vat_exemption?: boolean;
          vat_number?: string | null;
          tax_number?: string | null;
          is_sole_trader?: boolean;
          sole_trader_number?: string | null;
          above_intracomm_threshold?: boolean;
        };
      };
    },
    params: RequestParams = {}
  ) =>
    this.request<
      UpdateBrandsCompanyData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/company/${companyId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
 * @description Returns brand retailer relation
 *
 * @tags AnkorstoreInternal_Brands
 * @name GetBrandRetailer
 * @summary Get Retailer relation
 * @request GET:/api/internal/v1/brands/retailers/{retailerId}
 * @response `200` `GetBrandRetailerData` Brand Retailer relation
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  getBrandRetailer = (retailerId: string, params: RequestParams = {}) =>
    this.request<
      GetBrandRetailerData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/retailers/${retailerId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Update brand retailer relation
 *
 * @tags AnkorstoreInternal_Brands
 * @name UpdateBrandRetailer
 * @summary Update Brand Retailer relation
 * @request PATCH:/api/internal/v1/brands/retailers/{retailerId}
 * @response `200` `UpdateBrandRetailerData` Brand Retailer relation
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  updateBrandRetailer = (
    retailerId: string,
    data: {
      data?: any;
    },
    params: RequestParams = {}
  ) =>
    this.request<
      UpdateBrandRetailerData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/retailers/${retailerId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
 * @description Returns a list of marketing cards for a logged-in brand
 *
 * @tags AnkorstoreInternal_Brands
 * @name GetBrandMarketingCards
 * @summary Get brand's marketing cards
 * @request GET:/api/internal/v1/brands/marketing-cards
 * @response `200` `GetBrandMarketingCardsData` A list of marketing cards
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  getBrandMarketingCards = (params: RequestParams = {}) =>
    this.request<
      GetBrandMarketingCardsData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/marketing-cards`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Returns the latest LLM-generated quality scores for a brand's products, worst-scoring first. Always returns a list — an empty array means no scores have been computed yet. Use `filter[product_id]` to fetch the score for a single product, and `filter[max_tier]` to keep only the products that need attention. Results are paginated: without `page[limit]` you get the first 25 products, not the whole catalogue.
 *
 * @tags AnkorstoreInternal_Product Scoring
 * @name GetApiInternalV1BrandsProductScores
 * @summary Get product scores for a brand
 * @request GET:/api/internal/v1/brands/product-scores
 * @response `200` `GetApiInternalV1BrandsProductScoresData` OK
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getApiInternalV1BrandsProductScores = (query: GetApiInternalV1BrandsProductScoresParams, params: RequestParams = {}) =>
    this.request<
      GetApiInternalV1BrandsProductScoresData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/product-scores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
 * @description Returns the brand-level aggregate quality score, computed from the brand's per-product scores. Each product's total_points maps to a tier (excellent/good/needs_work/critical, worth 100/75/35/0 points respectively), and the aggregate is the average across the brand's products — see product-scoring/index.yaml for the underlying per-product scores.
 *
 * @tags AnkorstoreInternal_Product Scoring
 * @name GetApiInternalV1BrandsProductScoresAggregate
 * @summary Get a brand's aggregate product quality score
 * @request GET:/api/internal/v1/brands/product-scores/aggregate
 * @response `200` `GetApiInternalV1BrandsProductScoresAggregateData` OK
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getApiInternalV1BrandsProductScoresAggregate = (params: RequestParams = {}) =>
    this.request<
      GetApiInternalV1BrandsProductScoresAggregateData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/product-scores/aggregate`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Returns brand reactivation status
 *
 * @tags AnkorstoreInternal_Brands
 * @name BrandsActionStatus
 * @summary Get brand reactivation status
 * @request GET:/api/internal/v1/brands/reactivations/-actions/status
 * @response `200` `BrandsActionStatusData` Brand reactivation status
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `422` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unprocessable Entity : Data provided is invalid
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  brandsActionStatus = (params: RequestParams = {}) =>
    this.request<
      BrandsActionStatusData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/reactivations/-actions/status`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Update brand reactivation status
 *
 * @tags AnkorstoreInternal_Brands
 * @name BrandsActionTransition
 * @summary Update Brand Reactivation status
 * @request POST:/api/internal/v1/brands/reactivations/-actions/transition
 * @response `200` `BrandsActionTransitionData` Brand reactivation status
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `422` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unprocessable Entity : Data provided is invalid
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  brandsActionTransition = (
    data: {
      data: {
        type: BrandsActionTransitionTypeEnum;
      };
    },
    params: RequestParams = {}
  ) =>
    this.request<
      BrandsActionTransitionData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/reactivations/-actions/transition`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
 * @description List the Minimum Order Value settings of a brand This endpoint can be used only by brands.
 *
 * @tags AnkorstoreInternal_Minimum Order Value Settings
 * @name ListBrandsMinimumOrderValueSettings
 * @summary List the Minimum Order Value settings of a brand
 * @request GET:/api/internal/v1/brands/minimum-order-value-settings
 * @response `200` `ListBrandsMinimumOrderValueSettingsData` Collection of MinimumOrderValue Settings resources
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  listBrandsMinimumOrderValueSettings = (params: RequestParams = {}) =>
    this.request<
      ListBrandsMinimumOrderValueSettingsData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/minimum-order-value-settings`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Every entry creates a new Minimum Order Value, maintaining the history of changes. This endpoint can be used only by brands.
 *
 * @tags AnkorstoreInternal_Minimum Order Value Settings
 * @name CreateBrandsMinimumOrderValueSettings
 * @summary Save a new Minimum Order Value
 * @request POST:/api/internal/v1/brands/minimum-order-value-settings
 * @response `200` `CreateBrandsMinimumOrderValueSettingsData` MinimumOrderValue Settings resource
 * @response `201` `{
  \** An object describing the server's implementation *\
    jsonapi: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},
  \** MinimumOrderValueSettingsResource *\
    data: {
    type: "minimum-order-value-settings",
  \**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   *\
    id: string,
    attributes: {
    type: string,
    amount: number,
    currency: string,

},

},

}` MinimumOrderValue Settings resource
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `422` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unprocessable Entity : Data provided is invalid
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  createBrandsMinimumOrderValueSettings = (
    data: {
      data: {
        type?: CreateBrandsMinimumOrderValueSettingsTypeEnum;
        attributes: {
          type: CreateBrandsMinimumOrderValueSettingsTypeEnum1;
          amount: number;
        };
      };
    },
    params: RequestParams = {}
  ) =>
    this.request<
      CreateBrandsMinimumOrderValueSettingsData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/brands/minimum-order-value-settings`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
